import {ICompaniesStateModel} from './../../interfaces'

export const state: ICompaniesStateModel = {
    list: [],
    page: 1,
    perPage: 20,
    total: 0,
    dataIsLoading: false,
    selectedCompany: null,
    filter: {
        status: null,
        search: ''
    },
    sort: {
        direction: 'asc',
        sort: 'name'
    }
}